/** Please don't modify or unzip this content. It will be updated regularly **/
(function() {
  BoostPFS.inject(this);

  // Set global variable
  Globals.hasIntegration = true;

  // 3rd app compile template
  Integration.compileIntegrationTemplate = function (data, itemHtml) {
    // Inject badge + a caption placeholder we'll fill after Stamped renders
    var itemReviewsHtml =
      '<div class="boost-stamped-review" style="margin-bottom:4px;">' +
        '<span class="stamped-product-reviews-badge" ' +
          'data-id="' + data.id + '" ' +
          'data-product-title="' + data.title.replace(/"/g, '&quot;') + '" ' +
          'data-product-sku="' + (data.skus && data.skus[0] ? data.skus[0] : '') + '">' +
        '</span>' +
        '<span class="stamped-badge-caption boost-stamped-rating-text" ' +
          'data-stamped-id="' + data.id + '" ' +
          'style="display:block;font-size:13px;color:#555;margin-top:3px;"></span>' +
      '</div>';

    itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    return itemHtml;
  };

  // Helper: read rating & count from Stamped's injected markup and print "4.9 / 5.0 (279)"
  function enhanceStampedBadges() {
    document.querySelectorAll('.stamped-product-reviews-badge').forEach(function (badge) {
      var container = badge.closest('.boost-stamped-review') || badge.parentElement;
      if (!container) return;

      var caption = container.querySelector('.stamped-badge-caption');
      if (!caption || caption.dataset.modified === 'true') return;

      // Stamped puts both values on .stamped-badge
      var inner = badge.querySelector('.stamped-badge');
      if (!inner) return;

      var rating = inner.getAttribute('data-rating'); // e.g. "4.9"
      var aria   = inner.getAttribute('aria-label') || ''; // e.g. "Rated 4.9 out of 5 stars 279 reviews"
      var mCount = aria.match(/(\d+)\s+reviews?/i);
      var count  = mCount ? mCount[1] : '';

      /*if (rating) {
        caption.textContent = parseFloat(rating).toFixed(1) + ' / 5.0' + (count ? ' (' + count + ')' : '');
        caption.dataset.modified = 'true';
      } */
    });
  }

  Integration.call3rdIntegrationFunc = function() {
    if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges === 'function') {
      // Render Stamped stars
      StampedFn.loadBadges();
      // Give Stamped a moment to inject, then enhance
      setTimeout(enhanceStampedBadges, 600);

      // Keep it working for infinite scroll / filter changes
      var obs = new MutationObserver(function() { enhanceStampedBadges(); });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  };
})();
